import type { QueryOptionsOverride } from '../queryOptions.helpers';
import type { BannerDtoType } from './banners.schema';
import { queryOptions } from '@tanstack/react-query';
import { QueriesKeys } from '../queriesKeys';
import { bannersApi } from './banners.api';

export const USER_BANNERS_STALE_TIME = 5 * 60 * 1000; // 5 min

export const bannerQueryOptions = {
  /**
   *
   * @returns all user assigned banners without pagination
   */
  usersBanners: (options?: QueryOptionsOverride<Array<BannerDtoType>>) => queryOptions({
    queryKey: [QueriesKeys.usersBanners],
    queryFn: () => bannersApi.getUsersBanners(),
    ...options,
  }),
  /**
   *
   * @returns all default public banners without pagination
   */
  allPublicBanners: (options?: QueryOptionsOverride<Array<BannerDtoType>>) => queryOptions({
    queryKey: [QueriesKeys.allPublicBanners],
    queryFn: () => bannersApi.getPublic(),
    ...options,
  }),
};
